import React from "react";
import ReactPaginate from "react-paginate";
import './common.scss';

const Pagination = ({
  totalPages,
  handlePageChange,
  previousLabel = "Previous",
  nextLabel = "Next",
  currentPage, // Add currentPage prop
}) => {
  const pageCount = Math.max(Number(totalPages) || 1, 1);
  const isFirstPage = (currentPage || 1) <= 1;
  const isLastPage = (currentPage || 1) >= pageCount;

  const handlePageClick = (data) => {
    let selectedPage = data.selected + 1;
    handlePageChange(selectedPage);
  };

  return (
    <div className="flex justify-end mt-5">
      <ReactPaginate
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        previousClassName={isFirstPage ? "pagination-disabled" : "pagination-previous"}
        nextClassName={isLastPage ? "pagination-disabled" : "pagination-next"}
        previousLinkClassName={isFirstPage ? "pagination-disabled-link" : "pagination-previous-link"}
        nextLinkClassName={isLastPage ? "pagination-disabled-link" : "pagination-next-link"}
        disabledClassName={"pagination-disabled"}
        disabledLinkClassName={"pagination-disabled-link"}
        activeClassName={"active"}
        forcePage={Math.max((currentPage || 1) - 1, 0)}
      />
    </div>
  );
};

export default Pagination;
